import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import ReactGA from "react-ga4";
import { flatRoutesList } from "@/Routes";
import { PayfacLayout } from "@payfac/layouts";
import { BackofficeLayout } from "@backoffice/layouts";
import { IntegrationProvider } from "@/hooks";
import { theme } from "@/styles/theme";
import Fonts from "@/styles/Fonts";
import "@/styles/datePicker.css";
import "antd/dist/antd.css";
import "@/styles/global.scss";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClientPayfac } from "@/modules/shared/configs/query/query-client";
import { AuthProvider } from "./contexts";
import { Helmet } from 'react-helmet';
import { formatWhiteLabelNames } from "./utils";
import { getTenantConfig } from "./config/tenantConfig";
import { PreviewContextProvider } from "./contexts/PreviewContext";
import { CreditCardProvider } from "./hooks/useCreditCard";
import { PaymentRefreshProvider } from "./contexts/PaymentRefreshContext";
import { ToastProvider } from "./contexts/ToastContext";

function MyApp() {
  const routeComponents = flatRoutesList().map(({ path, element }, key) => (
    <Route path={path} element={element} key={key} />
  ));


  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("barte-user-info"));
    //@ts-ignore
    if (window?.userGuiding) {
      //@ts-ignore
      window?.userGuiding?.identify(user?.email ? user?.email : "login@paginalogin.com", {
        name: user?.email ? user?.email : "login@paginalogin.com",
        email: user?.email ? user?.email : "login@paginalogin.com",
        created_at: new Date(),
      })
    }
    if (!user || user.email.includes("@barte")) return;
    ReactGA.initialize([
      {
        trackingId: String(import.meta.env.VITE_GA_MEASUREID),
        gaOptions: {
          userId: user?.email,
        },
      },
    ]);
    ReactGA.set({ userId: user?.email });
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, [window.location.pathname]);



  useEffect(() => {
    //@ts-ignore
    const faviconLink = document?.getElementById('favicon');
    faviconLink?.setAttribute('href', `/src/favicon-${getTenantConfig().applicationName}.png`);
  }, []);

  return (
    <>
      <ChakraProvider theme={theme}>
        <ToastProvider>
          <Helmet>
            <title>{formatWhiteLabelNames(getTenantConfig().applicationName)}</title>
            <link id="favicon" rel="icon" />
          </Helmet>
          <Fonts />
          <BrowserRouter>
            <Routes>
              <Route path="/payfac/*" element={<PayfacLayout />} />
              <Route path="/hml-payfac/*" element={<PayfacLayout />} />
              <Route path="/bo/*" element={<BackofficeLayout />} />
              <Route path="/hml-bo/*" element={<BackofficeLayout />} />

              <Route
                path="/*"
                element={
                  <QueryClientProvider client={queryClientPayfac}>
                    <AuthProvider>
                      <PaymentRefreshProvider>
                        <CreditCardProvider>
                          <IntegrationProvider>
                            <PreviewContextProvider>
                                <Routes>
                                  {routeComponents}
                                </Routes>
                            </PreviewContextProvider>
                          </IntegrationProvider>
                        </CreditCardProvider>
                      </PaymentRefreshProvider>
                    </AuthProvider>
                  </QueryClientProvider>
                }
              />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </ChakraProvider>
    </>
  );
}

export default MyApp;
